import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { matchPath } from 'react-router-dom';
import { List } from '@material-ui/core';
import NavItem from './NavItem';
import useAuth from '../hooks/useCustomAuth';
import { useTranslation } from 'react-i18next';

const renderNavItems = ({ depth = 0, items, pathname }) => (
  <>
    {
      items.reduce(
        // eslint-disable-next-line no-use-before-define
        (acc, item) => reduceChildRoutes(
          acc,
          pathname,
          item,
          depth
        ), []
      )
    }
  </>
);

const hasPermission = (user, role) => {
  if (Array.isArray(role)) {
    return user.roles.some(r => role.indexOf(r) >= 0)
  }
  return user.roles.includes(role)
}

const reduceChildRoutes = (acc, pathname, item, depth) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const key = `${item.title}-${depth}`;
  const exactMatch = item.path ? !!matchPath({
    path: item.path,
    end: true
  }, pathname) : false;

  if (item.children && (!item.role || (hasPermission(user, item.role) && (!item.moduleID || (item.moduleID !== "" && user.userModules?.find(m => m.id === item.moduleID)?.enable))))) {
    const partialMatch = item.path ? !!matchPath({
      path: item.path,
      end: false
    }, pathname) : false;

    acc.push(
      <NavItem
        active={partialMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={partialMatch || acc.length <= 0}
        path={item.path}
        title={t(item.title) ? t(item.title) : item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          items: item.children,
          pathname
        })}
      </NavItem>
    );
  } else if (!item.role || (hasPermission(user, item.role) && (!item.moduleID || (item.moduleID !== "" && user.userModules?.find(m => m.id === item.moduleID)?.enable)))) {
    acc.push(
      <NavItem
        active={exactMatch}
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        path={item.path}
        title={t(item.title) ? t(item.title) : item.title}
      />
    );
  }

  return acc;
};

const NavSection = ({ items, pathname }) => {
  const [renderedItems] = useState(
    renderNavItems({
      items,
      pathname
    })
  );

  useEffect(() => {
  }, [pathname]);

  return (
    <List>
      {renderedItems}
    </List>
  );
};

NavSection.propTypes = {
  items: PropTypes.array,
  pathname: PropTypes.string
};

export default NavSection;
